import {getDevCenterDataStore} from '../../../app/store'
const initialState = { id: 'static-home-section'};

// List of of possible values for rhs reducers
const rhsReducerData = state =>state.rhsReducer;
const specData = state =>state.rhsReducer.specData;
const responseCodes = state => state.rhsReducer.responseCodes;
const testingTriggers = state => state.rhsReducer.testingTriggers;
const seeOverViewLink = state => state.rhsReducer.seeOverViewLink;
const developerGuideLink = state => state.rhsReducer.developerGuideLink;
const specDownloadLink = state => state.rhsReducer.specDownloadLink;
const hostSlice = state => state.rhsReducer.hostSlice;
const apiUrl = state => state.rhsReducer.apiUrl;
const categoryTagArrayContents = state => state.rhsReducer.categoryTagArrayContents;
const schema = state => state.rhsReducer.schema;
const xDevCenterMetaData = state => state.rhsReducer.xDevCenterMetaData;
const hasQueryParams = state => state.rhsReducer.hasQueryParams;
const hasMandatoryQueryParams = state => state.rhsReducer.hasMandatoryQueryParams;
const queryParameters = state => state.rhsReducer.queryParameters;
const queryParamsDefaultValues = state => state.rhsReducer.queryParamsDefaultValues;
const pathParameters = state => state.rhsReducer.pathParameters;
const headerParameters = state => state.rhsReducer.headerParameters; 
const queryParamsCurrentValues = state => state.rhsReducer.queryParamsCurrentValues;
const processor = state => state.rhsReducer.processor;
const processorName = state => state.rhsReducer.processorName;
const jsTree = state => state.rhsReducer.jsTree;
const responseTree = state => state.rhsReducer.responseTree;
const responseContent = state => state.rhsReducer.responseContent;
const responseCode = state => state.rhsReducer.responseCode;
const requestHeaders = state => state.rhsReducer.requestHeaders;
const responseHeaders = state => state.rhsReducer.responseHeaders;
const contentType = state => state.rhsReducer.contentType;
const queryParamsControl = state => state.rhsReducer.queryParamsControl;
const nodeClickCheck = state => state.rhsReducer.nodeClickCheck;
const clickedNode = state => state.rhsReducer.clickedNode;
const isRequestDescriptionExpanded = state => state.rhsReducer.isRequestDescriptionExpanded;
const isResponseActivated = state => state.rhsReducer.isResponseActivated;
const requestBuilderTabIndex = state => state.rhsReducer.requestBuilderTabIndex;
const liveConsoleTabIndex = state => state.rhsReducer.liveConsoleTabIndex;
const queryParametersCounter = state => state.rhsReducer.queryParametersCounter;
const urlCounter = state => state.rhsReducer.urlCounter;
const headerCounter = state => state.rhsReducer.headerCounter;
const responseProgressFlag = state => state.rhsReducer.responseProgressFlag;
const descriptionExpansionAlertFlag = state => state.rhsReducer.descriptionExpansionAlertFlag;
const jsTreeExpanded = state => state.rhsReducer.jsTreeExpanded;
const jsTreeExpandedFlag = state => state.rhsReducer.jsTreeExpandedFlag;
const requiredFields = state => state.rhsReducer.requiredFields;
const requiredFieldsFlag = state => state.rhsReducer.requiredFieldsFlag;

// function to generate rhs reducer
function rhsReducer(state=initialState, action)
{
    switch(action.type)
    {
        case 'UPDATE_SPEC_DATA':
            return {
            ...state,
            // and update the copy with the new value
            specData : action.specData
            }
        case 'UPDATE_RESPONSE_CODES':
            return {
            ...state,
            // and update the copy with the new value
            responseCodes : action.responseCodes
            }
        case 'UPDATE_TESTING_TRIGGER':
                return {
                ...state,
                // and update the copy with the new value
                testingTriggers : action.testingTriggers
                }
        case 'UPDATE_SEE_OVERVIEWLINK':
                return {
                    ...state,
                    // and update the copy with the new value
                seeOverViewLink : action.seeOverViewLink
                }
        case 'UPDATE_DEVELOPER_GUIDE_LINK':
                    return {
                        ...state,
                        // and update the copy with the new value
                        developerGuideLink : action.developerGuideLink
                }
        case 'UPDATE_SPEC_DOWNLOAD_LINK':
                    return {
                        ...state,
                        // and update the copy with the new value
                        specDownloadLink : action.specDownloadLink
                }                         
        case 'UPDATE_HOST':
            return {
            ...state,
            // and update the copy with the new value
            host : action.host
            }
        case 'UPDATE_API_URL':
                return {
                    ...state,
                    // and update the copy with the new value
                    apiUrl : action.apiUrl
            }    
        case 'UPDATE_CATEGORY_TAG_CONTENTS':
            return {
                ...state,
                // and update the copy with the new value
                categoryTagArrayContents : action.categoryTagArrayContents
            }        
        case 'UPDATE_SCHEMA':
            return {
                    ...state,
                    // and update the copy with the new value
                    schema : action.schema
            }
        case 'UPDATE_X-DEVCENTER-METADATA':
                return {
                        ...state,
                        // and update the copy with the new value
                        xDevCenterMetaData : action.xDevCenterMetaData
                        }    
        case 'UPDATE_JS_TREE':
                return {
                        ...state,
                        // and update the copy with the new value
                        jsTree : action.jsTree
                }           
        case 'UPDATE_HAS_QUERY_PARAMS':
            return {
                    ...state,
                        // and update the copy with the new value
                    hasQueryParams : action.hasQueryParams
                }
        case 'UPDATE_HAS_MANDATORY_QUERY_PARAMS':
            return {
                 ...state,
                                // and update the copy with the new value
                hasMandatoryQueryParams : action.hasMandatoryQueryParams
            }
        case 'UPDATE_QUERY_PARAMETERS':
                return {
                     ...state,
                                    // and update the copy with the new value
                    queryParameters : action.queryParameters
            }
        case 'UPDATE_QUERY_PARAMS_DEFAULT_VALUES':
                return {
                    ...state,
                    queryParamsDefaultValues: action.queryParamsDefaultValues

                }
        case 'UPDATE_HEADER_PARAMETERS':
                return {
                     ...state,
                                    // and update the copy with the new value
                    headerParameters : action.headerParameters
            }
        case 'UPDATE_PATH_PARAMETERS':
                return {
                     ...state,
                                    // and update the copy with the new value
                    pathParameters : action.pathParameters
        }
        case 'UPDATE_QUERY_PARAMETERS_CURRENT_VALUES':
                return {
                     ...state,
                                    // and update the copy with the new value
                    queryParamsCurrentValues : action.queryParamsCurrentValues
        }
        case 'UPDATE_PROCESSOR':
                return {
                     ...state,
                                    // and update the copy with the new value
                                    processor : action.processor
        }
        case 'UPDATE_PROCESSOR_NAME':
            return {
                 ...state,
                                // and update the copy with the new value
                                processorName : action.processorName
    }
        case 'UPDATE_RESPONSE_CONTENT':
                return {
                     ...state,
                                    // and update the copy with the new value
                                    responseContent : action.responseContent
        }
        case 'UPDATE_RESPONSE_TREE':
                return {
                    ...state,
                                    responseTree :action.responseTree
                }
        case 'UPDATE_RESPONSE_CODE':
                return {
                     ...state,
                                    // and update the copy with the new value
                                    responseCode : action.responseCode
        }
        case 'UPDATE_CONTENT_TYPE':
                return {
                     ...state,
                                    // and update the copy with the new value
                                    contentType : action.contentType
        } 
        case 'UPDATE_REQUEST_HEADERS':
                return {
                     ...state,
                                    // and update the copy with the new value
                                    requestHeaders : action.requestHeaders
        }
        case 'UPDATE_RESPONSE_HEADERS':
            return {
                 ...state,
                                // and update the copy with the new value
                                responseHeaders : action.responseHeaders
    }
        case 'UPDATE_QUERY_PARAMS_CONTROL':
                return {
                     ...state,
                                    // and update the copy with the new value
                                    queryParamsControl : action.queryParamsControl
        }
        case 'UPDATE_NODE_CLICK_CHECK':
            return {
                ...state,
                                   // and update the copy with the new value
                                   nodeClickCheck : action.nodeClickCheck
            }    
        case 'UPDATE_CLICKED_NODE':
            return {
                ...state,
                                    // and update the copy with the new value
                                    clickedNode : action.clickedNode
            }                        
        case 'UPDATE_IS_REQUEST_DESCRIPTION_EXPANDED':
            return {
                ...state,
                // and update the copy with the new value
                isRequestDescriptionExpanded : action.isRequestDescriptionExpanded
            } 
        case'UPDATE_IS_RESPONSE_ACTIVATED': 
            return {
                ...state,
                isResponseActivated : action.isResponseActivated  
            }
        case'UPDATE_REQUEST_BUILDER_TAB_INDEX': 
            return {
                ...state,
                requestBuilderTabIndex : action.requestBuilderTabIndex  
            } 
        case'UPDATE_LIVE_CONSOLE_TAB_INDEX': 
            return {
                ...state,
                liveConsoleTabIndex : action.liveConsoleTabIndex  
            }       
        case'UPDATE_QUERY_PARAMETERS_COUNTER': 
            return {
                ...state,
                queryParametersCounter : action.queryParametersCounter  
            }
        case'UPDATE_URL_PARAMETERS_COUNTER': 
            return {
                ...state,
                urlCounter : action.urlCounter  
            } 
        case 'UPDATE_HEADER_COUNTER':
            return {
                ...state,
                headerCounter : action.headerCounter
            }
        case 'UPDATE_RESPONSE_PROGRESS_FLAG':
            return {
                ...state,
                responseProgressFlag : action.responseProgressFlag
            }            
        case 'UPDATE_DESCRIPTION_EXPANSION_ALERT_FLAG':
            return {
                ...state,
                descriptionExpansionAlertFlag : action.descriptionExpansionAlertFlag
            }     
        case 'UPDATE_JS_TREE_EXPANDED':
            return {
                ...state,
                jsTreeExpanded : action.jsTreeExpanded
            }
        case 'UPDATE_JS_TREE_EXPANDED_FLAG':
            return {
                ...state,
                jsTreeExpandedFlag : action.jsTreeExpandedFlag
            }
        case 'UPDATE_REQUIRED_FIELDS':
            return {
                ...state,
                requiredFields: action.requiredFields
            }
        case 'UPDATE_REQUIRED_FIELDS_FLAG':
            return {
                ...state,
                requiredFieldsFlag: action.requiredFieldsFlag
            }
        case 'CLEANUP_API_DATA':
            return {
                ...state,
                ...action.payload
            }
        default:
            return state        
    }
}

// function to get lhs reducer data 
function getRHSReducerData()
{
    return rhsReducerData(getDevCenterDataStore().getState());
}

// function to get lhs reducer data 
function getSpecData()
{
    return specData(getDevCenterDataStore().getState());
}

// function to get response Codes
function getResponseCodes()
{
    return responseCodes(getDevCenterDataStore().getState());
}
// function to get Testing Triggers
function getTestingTriggers()
{
    return testingTriggers(getDevCenterDataStore().getState());
}

// function to get Testing Triggers
function getSeeOverViewLink()
{
    return seeOverViewLink(getDevCenterDataStore().getState());
}

// function to get Testing Triggers
function getDeveloperGuideLink()
{
    return developerGuideLink(getDevCenterDataStore().getState());
}

// function to get spec download link
function getSpecDownloadLink()
{
    return specDownloadLink(getDevCenterDataStore().getState());
}

// function to get host value
function getHost()
{
    return hostSlice(getDevCenterDataStore().getState());
}

// function to get host value
function getApiUrl()
{
    return apiUrl(getDevCenterDataStore().getState());
}
// function to get category tag contents
function getCategoryTagContents()
{
    return categoryTagArrayContents(getDevCenterDataStore().getState());
}

// function to get body params schema if provided.
function getSchema()
{
    return schema(getDevCenterDataStore().getState());
}

// function to get devcener .
function getxDevCenterMetaData()
{
    return xDevCenterMetaData(getDevCenterDataStore().getState());
}
// function to get has query params value 
function getHasQueryParams()
{
    return hasQueryParams(getDevCenterDataStore().getState());
}

// function to get has Mandatory query params schema if provided.
function getHasMandatoryQueryParams()
{
    return hasMandatoryQueryParams(getDevCenterDataStore().getState());
}

// function to get query params schema if provided.
function getQueryParameters()
{
    return queryParameters(getDevCenterDataStore().getState());
}

// function to get query params default values if provided.
function getQueryParamsDefaultValues()
{
    return queryParamsDefaultValues(getDevCenterDataStore().getState());
}
// function to get path parameters value
function getPathParameters()
{
    return pathParameters(getDevCenterDataStore().getState());
}
// function to get header parameters
function getHeaderParamters()
{
    return headerParameters(getDevCenterDataStore().getState());
}
// function to get query Parameters Current Values
function getQueryParamsCurrentValues()
{
    return queryParamsCurrentValues(getDevCenterDataStore().getState());
}


// function to get query Parameters Current Values
function getProcessorDropDown()
{
    return processor(getDevCenterDataStore().getState());
}

function getProcessorName()
{
    return processorName(getDevCenterDataStore().getState());
}

// function to get query Parameters Current Values
function getJsTree()
{
    return jsTree(getDevCenterDataStore().getState());
}

// function to get response payload
function getResponseContent()
{
    return responseContent(getDevCenterDataStore().getState());
}

// function to get response tree
function getResponseTree()
{
    return responseTree(getDevCenterDataStore().getState());
}

// function to get response Code
function getResponseCode()  
{
    return responseCode(getDevCenterDataStore().getState());
}

// function to get content type
function getContentType()  
{
    return contentType(getDevCenterDataStore().getState());
}

// function to get Request Headers
function getRequestHeaders()  
{
    return requestHeaders(getDevCenterDataStore().getState());
}

// function to get response headers
function getResponseHeaders()  
{
    return responseHeaders(getDevCenterDataStore().getState());
}

function getQueryParamsControl()
{
    return queryParamsControl(getDevCenterDataStore().getState());
}

function getNodeClickCheck(){
    return nodeClickCheck(getDevCenterDataStore().getState());
}

function getClickedNode(){
    return clickedNode(getDevCenterDataStore().getState());
}

function getIsRequestDescriptionExpanded(){
    return isRequestDescriptionExpanded(getDevCenterDataStore().getState());
}

function getIsResponseActivated(){
    return isResponseActivated(getDevCenterDataStore().getState());
}

function getRequestBuilderTabIndex(){
    return requestBuilderTabIndex(getDevCenterDataStore().getState());
}

function getLiveConsoleTabIndex(){
    return liveConsoleTabIndex(getDevCenterDataStore().getState());
}

function getQueryParametersCounter(){
    return queryParametersCounter(getDevCenterDataStore().getState());
}
function getUrlCounter(){
    return urlCounter(getDevCenterDataStore().getState());
}
function getHeaderCounter(){
    return headerCounter(getDevCenterDataStore().getState());
}
function getResponseProgressFlag(){
    return responseProgressFlag(getDevCenterDataStore().getState());
}
function getDescriptionExpansionAlertFlag(){
    return descriptionExpansionAlertFlag(getDevCenterDataStore().getState());
}
function getJsTreeExpanded(){
    return jsTreeExpanded(getDevCenterDataStore().getState());
}
function getJsTreeExpandedFlag(){
    return jsTreeExpandedFlag(getDevCenterDataStore().getState());
}
function getRequiredFields(){
    return requiredFields(getDevCenterDataStore().getState());
}
function getRequiredFieldsFlag(){
    return requiredFieldsFlag(getDevCenterDataStore().getState());
}
export default rhsReducer;
export {getRHSReducerData,getHost,getCategoryTagContents,getSchema,getxDevCenterMetaData,getQueryParamsDefaultValues,getHasQueryParams,getHasMandatoryQueryParams,getQueryParamsControl, getQueryParameters,getPathParameters,getHeaderParamters,getQueryParamsCurrentValues,getResponseCodes,getTestingTriggers,getApiUrl,getSeeOverViewLink,getDeveloperGuideLink,getSpecDownloadLink,getProcessorDropDown,getProcessorName,getJsTree,getResponseContent,getResponseTree,getResponseCode,getResponseHeaders,getContentType,getRequestHeaders,getSpecData,getNodeClickCheck,getClickedNode,getIsRequestDescriptionExpanded,getIsResponseActivated,getRequestBuilderTabIndex,getLiveConsoleTabIndex,getQueryParametersCounter,getUrlCounter,getHeaderCounter,getDescriptionExpansionAlertFlag,getJsTreeExpanded,getResponseProgressFlag,getJsTreeExpandedFlag,getRequiredFields,getRequiredFieldsFlag}
